"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeTextPopper = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Shadow_1 = require("./Shadow");
const FreeTextPopper = ({ children, renderNoSuggestions, autoComplete, open, 
// categories = [],
// selectedCategory,
// selectCategory,
className, getPopupElem = () => null, style, inNoResultsState, noScrollDropdownResults }) => {
    // const { popper, chip, chipContainer } = autoComplete;
    const { popper } = autoComplete;
    const StyledPopper = (0, styled_1.default)('div') `
    ${popper}
    & .MuiAutocomplete-listbox {
      ${() => (noScrollDropdownResults ? 'max-height: none;' : '')}
    }
  `;
    const [shadowType, setShadowType] = (0, react_1.useState)('right');
    const bottomShadow = (0, react_1.useRef)(null);
    (0, Shadow_1.useShowHideShadow)({ ref: bottomShadow, getPopupElem, setShadowType });
    // const ChipContainer = styled('div')(chipContainer);
    // const Chip = styled('span')(chip);
    // const Chips = ['All', ...categories].map((name, index) => (
    //   <Chip
    //     className={name === selectedCategory ? 'active' : ''}
    //     key={`chip-${name}-${index}`}
    //     onClick={() => selectCategory(name)}
    //   >
    //     {name}
    //   </Chip>
    // ));
    // TODO can this come out after we roll out MUI 5? (https://healthsparq.atlassian.net/browse/HSAP-1616)
    if (!open) {
        return null;
    }
    return (react_1.default.createElement(StyledPopper, { className: className, style: style, "data-testid": "sw-popper", id: "sw-popper", "data-ref": "popper", "data-name": "sw-popper" },
        inNoResultsState ? renderNoSuggestions() : children,
        shadowType === 'right' && react_1.default.createElement(Shadow_1.RightInnerShadow, null),
        shadowType === 'rightBottom' && (react_1.default.createElement(Shadow_1.BottomRightInnerShadow, { ref: bottomShadow }))));
};
exports.FreeTextPopper = FreeTextPopper;
//# sourceMappingURL=FreeTextPoppper.js.map